export const cewPageSchema = `
{
    "@context": "https://schema.org",
    "@type": "Corporation",
    "name": "Charter Communications",
    "description": "At Charter Communications, we connect our customers to innovation. See how our blazing fast and secure broadband network powers the future.",
    "department":
    [
        {
        "name": "Spectrum Customer Service",
        "description": "Contact customer service, explore popular topics, read support articles and get chat support. At Spectrum, we're here to help.",
        "telephone": "+18332676094"
        }
    ]
}
`;
